import { render, staticRenderFns } from "./MarksEntryRubrics.vue?vue&type=template&id=10f0dc1c&scoped=true&"
import script from "./MarksEntryRubrics.vue?vue&type=script&lang=js&"
export * from "./MarksEntryRubrics.vue?vue&type=script&lang=js&"
import style0 from "./MarksEntryRubrics.vue?vue&type=style&index=0&id=10f0dc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0dc1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSimpleTable,VSnackbar,VTextField})
